function AdminContact() {
    return <p>AdminContact</p>;
}

export default AdminContact;
